import React from 'react'
import OrderDetail from './OrderDetail/OrderDetailListing/OrderDetail'
import OrderInfo from './OrderDetail/OrderInfo/OrderInfo'
import ShowAlert from 'src/component/Global/ShowAlert'

const OrderDetails = () => {
    return (
        <>
            <div id="main" className="order-detail-page">
                <ShowAlert doNotShow={['orderDetailNotFound']}/>
                <div className="container">
                    <OrderInfo />
                    <OrderDetail />
                </div>
            </div>
        </>
    )
}

export default OrderDetails